import {
  AllCandidateBLASTUiParamsType,
  CommonBLASTParamValues,
  MatrixToGapCosts,
  UnwrappedBLASTParamsType,
} from 'search/blast/parameters/common';
import {BLASTMatrix, TBLASTNTask} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

export type CandidateTBLASTNUiParamsType = Pick<
  AllCandidateBLASTUiParamsType<TBLASTNTask>,
  'task' | 'evalue' | 'word_size' | 'culling_limit' | 'gap_cost' | 'matrix' | 'comp_based_stats'
>;

export type TBLASTNUiParamsType = UnwrappedBLASTParamsType<CandidateTBLASTNUiParamsType>;

const CommonTBLASTNParams: Pick<
  CandidateTBLASTNUiParamsType,
  'evalue' | 'culling_limit' | 'gap_cost' | 'matrix' | 'comp_based_stats'
> = {
  ...pickDefined(CommonBLASTParamValues, 'evalue', 'culling_limit', 'gap_cost', 'matrix', 'comp_based_stats'),
};

export const DefaultTBLASTNParams: CandidateTBLASTNUiParamsType = {
  ...CommonTBLASTNParams,
  task: {defaultValue: TBLASTNTask.TBLASTN, values: Object.values(TBLASTNTask)},
  word_size: {
    values: [2, 3, 4, 6],
    defaultValue: 3, // from the blastp program, not from NCBI
  },
};

export const DefaultTBLASTNFastParams: CandidateTBLASTNUiParamsType = {
  ...CommonTBLASTNParams,
  task: {defaultValue: TBLASTNTask.TBLASTNFast, values: Object.values(TBLASTNTask)},
  word_size: {
    values: [2, 3, 4, 6],
    defaultValue: 6, // from the blastp program, not from NCBI
  },
};

export const getCandidateTBLASTNUiParams = (
  task?: TBLASTNTask,
  matrix?: BLASTMatrix
): CandidateTBLASTNUiParamsType => {
  if (!matrix) {
    switch (task) {
      case TBLASTNTask.TBLASTNFast:
        return DefaultTBLASTNFastParams;
      default:
        return DefaultTBLASTNParams;
    }
  } else {
    const baseParams = getCandidateTBLASTNUiParams(task);
    return {
      ...baseParams,
      matrix: {
        ...baseParams.matrix,
        defaultValue: matrix,
      },
      gap_cost: MatrixToGapCosts[matrix],
    };
  }
};
